import { render, staticRenderFns } from "./courseBook.vue?vue&type=template&id=4194ab7a&scoped=true&"
import script from "./courseBook.vue?vue&type=script&lang=js&"
export * from "./courseBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4194ab7a",
  null
  
)

export default component.exports